import React from 'react';
import downLight from "../../../../../assets/downLight.svg";
import downDark from "../../../../../assets/downDark.svg";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";

interface ModelButtonProps {
    model: string;
    theme: string;
    setIsOpen: (isOpen: boolean) => void;
    isOpen: boolean;
}

const ModelButton: React.FC<ModelButtonProps> = ({ model, theme, setIsOpen, isOpen}) => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    return (
        <button
            className="flex w-full px-2.5 py-1 text-black dark:text-white rounded-lg hover:bg-neutral-200 dark:hover:bg-neutral-800 hover:bg-opacity-10"
            onClick={() => setIsOpen(!isOpen)}
        >
            <span>{model}</span>
            <img
                src={`${theme === 'dark' ? downLight : downDark}`}
                alt=""
                className={`ml-1 h-4 w-4 ${environment === "vscode" ? "" : "mt-1"}`}
            />
        </button>
    )
};

export default ModelButton;